import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import ReferralConsentBanner from './components/ReferralConsentBanner'

const TrustBar = lazy(() => import('./components/TrustBar'))
const Features = lazy(() => import('./components/Features'))
const HowItWorks = lazy(() => import('./components/HowItWorks'))
const Pricing = lazy(() => import('./components/Pricing'))
const Team = lazy(() => import('./components/Team'))
const FAQ = lazy(() => import('./components/FAQ'))
const Contact = lazy(() => import('./components/Contact'))
const WhyFyr = lazy(() => import('./components/WhyFyr'))
const Footer = lazy(() => import('./components/Footer'))
const Impressum = lazy(() => import('./components/Impressum'))
const AGB = lazy(() => import('./components/AGB'))
const Datenschutz = lazy(() => import('./components/Datenschutz'))
const AffiliatePartnerApply = lazy(() => import('./components/AffiliatePartnerApply'))

function LoadingFallback() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-white">
      <div className="w-10 h-10 border-3 border-orange-100 border-t-orange-500 rounded-full animate-spin" />
      <span className="text-sm text-neutral-400 font-medium">Loading FindYourRisk...</span>
    </div>
  )
}

function LandingPage() {
  return (
    <>
      <Navbar />
      <Hero />
      <TrustBar />
      <Features />
      <HowItWorks />
      <Pricing />
      <Team />
      <FAQ />
      <Contact />
      <WhyFyr />
      <Footer />
      <ReferralConsentBanner />
    </>
  )
}

export default function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/partner-werden" element={<AffiliatePartnerApply />} />
        </Routes>
      </div>
    </Suspense>
  )
}